import { environment as env } from '@kolytics/envs';
export const environment = env;
